export const DISPLAY_DEBUG_DURATION_MS = 15_000;

export function isDisplayDebugEnabled({ isDevelopment, search }: { isDevelopment: boolean; search: string }): boolean {
  return isDevelopment || new URLSearchParams(search).get("display.debug") === "true";
}
